import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { emitStockholmPageView } from "../lib/analytics";

/** GA4 SPA page views use pathname only so visitor-authored queries stay out. */
export function StockholmPageViewTracker(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    emitStockholmPageView(pathname);
  }, [pathname]);

  return null;
}
